import { styled } from '@mui/material';
import classNames from 'classnames';

import { ENOPOrganType } from '#shared';

const PREFIX = 'TSMED-AviationFurtherPath';
const aviationFurtherPathClasses = {
  root: `${PREFIX}-root`,
};

const Root = styled('polyline')(({ theme: { palette, mixins } }) => ({
  [`&.${aviationFurtherPathClasses.root}`]: {
    ...mixins.organStyles(palette, { prefix: `&` }),
    ['@keyframes dash']: {
      from: {
        strokeDashoffset: 300,
      },
      to: {
        strokeDashoffset: 0,
      },
    },
    strokeDasharray: '4 3',
    fill: 'none',
    opacity: 0.3,
    stroke: 'black',
    strokeWidth: 2,
    transition: 'all 250ms ease-in-out',
    animation: 'dash 10s linear forwards infinite',
    color: 'var(--primaryColor, black)',
    [`&.highlighted`]: {
      stroke: 'currentColor',
      opacity: 1,
    },
  },
}));
interface AviationFurtherPathProps {
  organ: ENOPOrganType | null;
  points: string;
  highlighted?: boolean;
}

export const AviationFurtherPath = ({
  organ,
  points,
  highlighted,
}: AviationFurtherPathProps) => (
  <Root
    className={classNames(aviationFurtherPathClasses.root, {
      highlighted,
      [`organ-type-${organ}`]: !!organ,
    })}
    points={points}
  />
);
